import React, { useState } from "react";

//UI Material
import {
  Button,
  Card,
  CircularProgress,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

//Local components
import SetSupplierDrawer from "../drawers/SetSupplierDrawer";
import ModalWindow from "../Modal";

//Material Icons
import { Delete, Edit } from "@mui/icons-material";

export default function SupplierInfo({ data, getSupplier }) {
  // ==========>Component States<==========
  //State for open/close drawer for set product
  const [openDrawer, setOpenDrawer] = useState(false);
  //State for loading in delete request
  const [isLoading, setIsLoading] = useState(false);
  //State for error in delete request
  const [isError, setIsError] = useState(false);
  //Open modal for delete confirmation/response
  const [openModal, setOpenModal] = useState(false);

  return (
    <Card raised sx={{ height: "100%" }}>
      <Grid container sx={{ padding: "20px" }} spacing={1}>
        <SetSupplierDrawer
          open={openDrawer}
          setOpen={setOpenDrawer}
          existingSupplierData={data}
          getData={getSupplier}
          isNewSupplier={false}
        />
        <Grid item xs={12} align="left">
          <Typography variant="h6" fontWeight="bold">
            Información del proveedor
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="left">
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Información principal del proveedor
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Nombre del proveedor
            </Typography>
            <Typography variant="body2">{data.name}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Identificación del proveedor
            </Typography>
            <Typography variant="body2">{data.identification}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Correo electrónico
            </Typography>
            <Typography variant="body2">{data.email}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Número telefónico
            </Typography>
            <Typography variant="body2">{data.phoneNumber}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Información adicional
            </Typography>
            <Typography variant="body2">{data.additionalInfo}</Typography>
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="left">
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Dirección del proveedor
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Provincia/Estado
            </Typography>
            <Typography variant="body2">{data.province}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              País
            </Typography>
            <Typography variant="body2">{data.country}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Dirección y otras señas
            </Typography>
            <Typography variant="body2">{data.address}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="left">
          <Typography variant="h7" fontWeight="bold" color="secondary">
            Información de facturación
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Número de cuenta bancaria
            </Typography>
            <Typography variant="body2">{data.accountNumber}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Tipo de pago
            </Typography>
            <Typography variant="body2">{data.paymentType}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Plazo de pago
            </Typography>
            <Typography variant="body2">{data.paymentTerm}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack
            alignItems="flex-start"
            justifyContent="flex-start"
            textAlign="left"
          >
            <Typography variant="body2" fontWeight="bold">
              Tiempo de entrega
            </Typography>
            <Typography variant="body2">{data.deliveryTime}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={12} align="right">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
          >
            <Button
              variant="contained"
              color="secondary"
              size="small"
              sx={{ color: "white" }}
              endIcon={<Edit />}
              onClick={() => {
                setOpenDrawer(true);
              }}
            >
              EDITAR proveedor
            </Button>
            {isLoading ? (
              <CircularProgress size={25} />
            ) : (
              <Button
                variant="contained"
                size="small"
                color="error"
                sx={{ color: "white" }}
                endIcon={<Delete />}
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                Remover proveedor
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={openModal}
        handleClose={() => {
          setOpenModal(false);
        }}
        leftText="Cancelar"
        leftClick={() => {
          setOpenModal(false);
        }}
        rightText="Sí, Remover"
        rightColor="error"
        //rightClick={deleteProduct}
        title="Remover ítem"
        text="¿Desea remover este proveedor permanentemente del sistema?"
      />
      <ModalWindow
        isOpen={isError}
        handleClose={() => {
          setIsError(false);
        }}
        leftText="Ok"
        leftClick={() => {
          setIsError(false);
        }}
        title="No se pudo realizar la acción"
        text="No se pudo remover el proveedor, por favor intente nuevamente."
      />
    </Card>
  );
}
